import React from 'react';
import styled from 'styled-components';

import { Flex } from 'Components/Base';

const InnerLayout = styled((props) => {
  return <Flex data-testid={'inner-layout'} {...props} />;
})`
  flex: 1;
  flex-direction: column;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  overflow: auto;
  padding: 16px 24px;
  padding-top: 16px;
  padding-bottom: 32px;

  &::-webkit-scrollbar {
    display: none;
  }

  @media (max-width: 768px) {
    height: 100%;
    padding-bottom: 60px;
    padding-left: 16px;
    padding-right: 16px;
  }
`;

export default InnerLayout;
